import { ExistingDestination } from "@prequel/react";

import axios, { ApiResponse, ApiRoutes, ErrorResponse } from "@/api/client";
import { TransferReportDay } from "@/types";

const getTransferReport: ({
  destinationID,
}: {
  destinationID: ExistingDestination["id"] | undefined;
}) => Promise<TransferReportDay[]> = ({ destinationID }) => {
  // now - (31 days in seconds)
  const [oneMonthAgoDateString] = new Date(Date.now() - 2678e6).toISOString().split("T");
  const [tomorrowDateString] = new Date(Date.now() + 8640e4).toISOString().split("T");

  const trailingDays = 30;

  return axios
    .get(ApiRoutes.REPORT_TRANSFERS, {
      params: {
        start: oneMonthAgoDateString,
        end: tomorrowDateString,
        page_size: trailingDays,
        order: "desc",
        destinations: destinationID || "",
      },
    })
    .then((response: ApiResponse<TransferReportDay[]>) => response.data.data)
    .catch((reason: ErrorResponse) => {
      const e = {
        error: {
          message: reason.response?.data?.message || "Failed to fetch transfer report.",
          suppressGlobalNotification: true,
          statusCode: reason.response?.status,
        },
      };
      throw e;
    });
};

const TransferReportService = {
  getTransferReport,
};
export default TransferReportService;
